import React, { useState } from "react";
import { downloads } from "../../../store/actions/downloads";
import { useSelector, useDispatch } from "react-redux";
import Table from "react-bootstrap/Table";

const Exceptions = () => {
  const [radioValue, setRadioValue] = useState("CREATE");
  const [proposalNumber, setProposal] = useState({
    propsal: "",
    error: false,
  });
  const downloadsExceptionData = useSelector(
    (state) => state.downloads && state.downloads.downloadsException
  );
  const dispatch = useDispatch();

  const inputHandler = (e) => {
    setProposal({ propsal: e.target.value, error: false });
  };

  const radios = [
    { name: "CREATE", value: "1" },
    { name: "SEARCH", value: "2" },
    { name: "SUBMIT", value: "3" },
  ];

  const searchItem = (event) => {
    event.preventDefault();
    if (proposalNumber.propsal) {
      const path = `exceptions/${radioValue}/${proposalNumber.propsal}`;
      dispatch(downloads(path, "exception"));
    } else {
      setProposal({ ...proposalNumber, error: true });
    }
  };

  const getCellHeaders = () => (
    <tr>
      <th>S.No.</th>
      <th>Category</th>
      <th>Message</th>
      <th>Type</th>
      <th>Field</th>
      <th>Table</th>
    </tr>
  );

  const getBody = () =>
    downloadsExceptionData &&
    downloadsExceptionData.exceptions &&
    downloadsExceptionData.exceptions.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.exceptionCd}</td>
        <td>{item.exceptionMessage}</td>
        <td>{item.exceptionTypeCd}</td>
        <td>{item.fieldReference}</td>
        <td>{item.tabId}</td>
      </tr>
    ));

  return (
    <>
      <div className="downloads-page__panel">
        <p className="downloads-page__hint">
          Enter proposal number to find exceptions
        </p>

        <div className="downloads-page__toggle-row">
          {radios.map((radio) => (
            <button
              key={radio.name}
              type="button"
              className={`downloads-page__toggle ${
                radioValue === radio.name ? "selected" : ""
              }`}
              onClick={() => setRadioValue(radio.name)}
            >
              {radio.name}
            </button>
          ))}
        </div>

        <form className="downloads-page__search-form" onSubmit={searchItem}>
          <div className="downloads-page__field">
            <label className="downloads-page__label" htmlFor="exception-proposal">
              Proposal Number
            </label>
            <input
              id="exception-proposal"
              onChange={inputHandler}
              value={proposalNumber.propsal}
              className="downloads-page__input"
              type="text"
              placeholder="Enter proposal number"
              name="proposalNumber"
            />
          </div>
          {proposalNumber.error && (
            <div className="downloads-page__error">
              Please enter proposal number
            </div>
          )}
          <div className="downloads-page__actions">
            <button
              type="submit"
              className="downloads-page__btn downloads-page__btn--primary"
            >
              Search
            </button>
          </div>
        </form>
      </div>

      {downloadsExceptionData && (
        <div className="proposal-dashboard__table-section downloads-page__table-section">
          <div className="proposal-table">
            <Table responsive striped bordered hover variant="light">
              <thead>{getCellHeaders()}</thead>
              <tbody>{getBody()}</tbody>
            </Table>
          </div>
        </div>
      )}
    </>
  );
};

export default Exceptions;
